import script from "./TariffNotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TariffNotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./TariffNotificationModal.vue?vue&type=style&index=0&id=14cd05fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14cd05fe"]])

export default __exports__